<template>
  <div class="play-container">
    <top-bar :user="this.user" />
    <Menu :user="this.user" :menuSelected="{ coinsCustomer: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/cms-mkt/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/cms-mkt/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/cms-mkt/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/cms-mkt/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/cms-mkt/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <Menu :user="this.user" :menuSelected="{ coinsCustomer: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
        'dashboard-beneficiary': true,
      }">
        <div>
          <div class="account-title ">
            <h1>{{ $t("cmsLang.campaignTitle") }}
               </h1>
            <br />
          </div>
          
          <div class="d-flex flex-wrap">
            <div class="container-fluid d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.customerCodeLabel") }}</small>
              <input type="number" v-model="customerCode" class="formedituser w-30" onwheel="return false;" />
            </div>
            <div class="container-fluid d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.productLabel") }}</small>
              <!-- <input type="text" v-model="newCampaign.category" class="formedituser w-100" /> -->
              <div class="radioButtonCustom">
                <label v-for="(product, index) in products" :key="index">
                  <input name="channeltype" type="radio" :value="product"
                    @change="selectProduct($event.target, product)" :checked="product === productSelected">
                  {{ $t('cmsLang.product_' + product) }}</label>
              </div>
            </div>
            <br />
            <div class="container-fluid d-flex flex-column align-items-baseline w-80">
            <small class="text-break">{{ $t("cmsLang.uploadFileLabel") }}</small>
             <!-- @click="$refs.fileInput1.click()" -->
            <div class="uploadImageDiv w-100 ">
                <input type="file" @change="uploadFile()" ref="fileInput1" 
                  accept=".xls, .xlsx" />
                <div class="w-100 text-left">
                  <a @click="resetFile" class="status-background background-will-expire color-darkgrey">Reset</a>
                </div>
              </div>
            </div>
            <br />
            <!-- <div v-if="this.submittedGames === null || this.submittedGames === undefined
            ">
            <div class="loading">
              <img src="@/assets/images/cms-mkt/loading.gif" />
            </div>
          </div>
          <div v-else class="d-flex flex-wrap">
            <campaign-case v-for="(entry, index) in submittedGames" :key="index" :campaign="entry" :user="user"
            :editable="false" @showdetails="showDetails" />
          </div> -->
        </div>
        <div>
          <a @click="submitCampaign()" class="button-all button-blue">
            {{ $t('cmsLang.saveLabel') }}
          </a>
          </div>
        </div>

      </div>
    </div>

    <!-- <modal-loading /> -->
    <ResetPassword v-if="this.isUserNew(this.user)" :user="this.user" />
    <!-- <PartnersPopup :user="this.user" @showinfo="showPopupInfo" /> -->
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/cms-mkt/close-button.svg" />
        </a>
        <br />
        <div v-if="this.error">
          <p >{{ this.error.description ? this.error.description : $t('cmsLang.errorMessage_' + this.error.code) }}</p>
        </div>
        <div v-else>
          <br />
          <p>{{ $t('cmsLang.' + this.successMessage) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Menu from "@/components/cms-mkt/Menu.vue";
  import TopBar from "@/components/cms-mkt/TopBar.vue";
  import Cookies from "js-cookie";
  import httpServiceCustomer from "@/http/http-play.js";
  import ResetPassword from "@/components/fragments/cms-mkt/ResetPasswordPopup.vue";
  // import PartnersPopup from "@/components/fragments/cms-mkt/ManagePartnerPopup.vue";
  import utils from "@/plugins/utils.js";

  // import ModalLoading from "@/components/fragments/cms-mkt/ModalLoading.vue";

  export default {
    name: "coinsCustomerCampaign",

    components: {
      // ModalLoading,
      TopBar,
      Menu,
      ResetPassword,
      // PartnersPopup
    },
    data() {
      return {
        user: null,
        products: [11, 12, 13, 14, 15],
        submittedGames: null,
        error: null,
        productSelected: null,
        campaignId: null,
        fileUploaded: null,
        customerCode: null,
        successMessage: "",
        isLoading: false,

      };
    },
    methods: {
      getAllSubmittedGames() {
        this.getSubmittedCampaigns(false);
        this.getSubmittedCampaigns(true);
      },
      showPopupInfo(successMessage, error) {
        this.selectedGameType = "";
        this.successMessage = successMessage;
        this.error = error;
        this.showModalPopup("modal_popup_info", true);
      },
      getActiveCoinMission() {
        this.daily = null;
        var offersData = "?type=C";
        offersData += "&status=A";
        offersData +=
          "&per_page=1" +
          "&page=1" +
          httpServiceCustomer.customerService
            .searchGames(offersData, Cookies.get("token"))
            .then(function (response) {
              return response;
            })
            .catch((error) => {
              this.error = error.response.data;
            })
            .then((response) => {
              if (response.status == 200) {
                if (response.data.length > 0) {
                  this.campaignId = response.data[0].mission_id;
                } else {
                  this.error = "NO_ACTIVE_CAMPAIGN"
                }
              }
            });
      },
      selectProduct(element, product) {
        this.productSelected = product;
      },
      uploadFile() {
        this.imageError = null;
        this.fileUploaded = null;
        let input = this.$refs.fileInput1;

        let file = input.files;
        if (file && file[0]) {

          let readerReward = new FileReader();
          readerReward.onload = (e) => {
            if (!e) {
              this.fileUploaded = btoa(readerReward.content);
            } else {
              this.fileUploaded = btoa(e.target.result);
            }
          };
          // reader.readAsDataURL(file[0]);
          if (readerReward.readAsBinaryString) {
            readerReward.readAsBinaryString(file[0]);
          } else {
            alert("This browser does not support HTML5.");
          }


        }
      },
      submitCampaign() {
        this.error = null;
        if (this.product === null){
          this.error = {code:"INVALID_PRODUCT"}
        } else if (this.customerCode === null){
          this.error = {code:"INVALID_CODHD"}
        } else if (this.fileUploaded === null){
          this.error = {code:"INVALID_FILE_01"}
        }
        if (this.error !== null){
          this.showModalPopup("modal_popup_info", true);
          return;
        }
        this.showModalPopup("modal_popup_loading_cms", true);
        httpServiceCustomer.customerService
          .addNewCoinCampaign(
            {
              codhd: this.customerCode,
              product: this.productSelected,
              mission_id: this.campaignId,
              content: this.fileUploaded
            },
            Cookies.get("token")
          ).catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.successMessage = "coinCampaignAddSuccess";
              this.resetFile();
            } else {
              this.error = response.data;
            }
            this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
          })
          .catch((error) => {
            console.log(error);
            this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
          });
      },
      resetFile() {
        this.$refs.fileInput1.value = null;
        this.fileUploaded = null;
        this.error = null;
      },
    },
    mounted() {
      this.getActiveCoinMission();
    },
    computed: {},
    created() {
      this.user = this.getUser();
    },
  };
</script>

<style scoped src="@/assets/styles/mkt-cms.css" />
<style src="vue-multiselect/dist/vue-multiselect.min.css" />
<style src="@/assets/styles/multiselect.css" />

<style scoped>
  .right {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .left {
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }

  .left small {
    padding-right: 10px;
  }

  .left .status_11 {
    color: #FF0000;
  }

  .left .status_10 {
    color: #7ea800;
  }

  .left .status_12 {
    color: #FF0000;
  }

  .left .status_13 {
    color: #3C4645;
  }

  .content-delivery {
    flex-direction: column;
    margin-bottom: 20px;
  }

  .content-delivery .personimg {
    width: 64px;
    height: 64px;
    border-radius: 100%;
    margin: 20px;
  }

  .offer_header {
    width: 100%;
    border-bottom: 1px solid #dcdee3;
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
  }

  .offer_details {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .offer_details .image {
    max-width: 80px;
    max-height: 80px;
    margin: 10px;
    padding: 30px;
  }

  .offer_details .imageDiv {
    /* height: 128px;
  width: 128px !important;
  margin: 10px; */
    border-radius: 100%;
    border: 1px solid #dcdee3;
    margin: 10px;
    width: 140px;
    height: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .button-red {
    border: 1px solid #FF0000;
    border-radius: 100px !important;
  }

  .multiselect {
    width: 50% !important;
    border: 1px solid #d8d8d8;
    background: #f1f1f1 !important;

  }

  .margin-y-10 {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .uploadImageDiv{
    padding-top: 20px;
    padding-bottom: 20px;
  }
</style>
